import DOMPurify, { type WindowLike } from "dompurify";
import { JSDOM } from "jsdom";
import { serverOnly$ } from "vite-env-only/macros";

// DOMPurify sanitizes HTML using a DOM. In the browser it uses the global
// `window`, but during server-side rendering there is no DOM, so we back it
// with a jsdom `window` created once and reused for every call.
const serverPurifier = serverOnly$(DOMPurify(new JSDOM("").window as unknown as WindowLike));

const purifier = serverPurifier ?? DOMPurify;

/**
 * Sanitizes an untrusted HTML string. Use this for any value passed to
 * `dangerouslySetInnerHTML` that originates from user data.
 *
 * Works during SSR and in the browser.
 */
export const sanitizeHtml = (html: string | null | undefined): string =>
  purifier.sanitize(html ?? "");
